import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";
import { useParams } from "react-router-dom";

export const useFetchEntityGroups = () => {
  const callApi = useApi();
  const { sport, organizationId } = useParams();

  return useQuery({
    queryKey: ["entityGroups", sport, organizationId],
    queryFn: () =>
      callApi(`/${sport}/o/${organizationId}/entityGroups`, {
        defaultErrorMessage: "Can't fetch clubs",
      }),
  });
};
